import {
    ProcessFieldBase,
    ProcessFieldTable,
    ServiceVM,
} from '@shared/types/process';
import { TableField } from '@features/TableField/TableField';

interface Props {
    field: ProcessFieldBase & ProcessFieldTable;
    service?: ServiceVM;
    disabled?: boolean;
    readOnly?: boolean;
    name?: string;
}

export function ProcessFieldTableField({
    field,
    service,
    ...props
}: Props) {
    return <TableField field={field} service={service} {...props} />;
}
